<template>
    <div v-if="client">
        <!-- messenger settings -->
        <p class="title is-5">Messenger settings</p>

        <!-- available messengers -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Available messengers</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div v-for="messenger in messengers" :key="messenger" class="switch-item">
                        <input
                            :id="messenger"
                            :name="messenger"
                            type="checkbox"
                            class="switch"
                            :checked="client.settings.messengerSettings.availableMessengers.indexOf(messenger) > -1"
                            @change="toggleMessenger(messenger)"
                        />
                        <label :for="messenger">{{messenger}}</label>
                    </div>
                </div>
            </div>
        </div>

        <!-- providers -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Providers</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <table class="table is-striped">
                        <tr v-for="(prov, index) in client.settings.messengerSettings.providers" :key="prov.type">
                            <!-- <td>{{prov.type}}</td> -->
                            <td>
                                <div class="select">
                                    <select v-model="prov.type">
                                        <option
                                        v-for="providerType in providerTypes"
                                        :key="providerType"
                                        :value="providerType">{{ providerType }}</option>
                                    </select>
                                </div>
                                
                            </td>
                            <td><input v-model="prov.provider" class="input" type="text" /></td>
                            <td><button class="button is-danger" @click="deleteProvider(index)">Delete</button></td>
                        </tr>
                    </table>
                    <button class="button is-success" @click="addProvider()">Add</button>
                </div>
            </div>
        </div>

        <div class="field-body">
            <div class="field is-grouped">
                <div class="control">
                    <button @click="save" class="button is-primary">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import state from '../../../../state';
import utils from '../../../../utils';
import clientService from '../../../../services/client.service';

export default {
    name: 'client-settings-messengers',
    data() {
        return {
            client: null,
            messengers: ['sms', 'wa', 'tg', 'vb'],
            providerTypes: ['email', 'sms', 'wa', 'tg', 'vb'],
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
        },
        toggleMessenger(messenger) {
            if (this.client.settings.messengerSettings.availableMessengers.indexOf(messenger) > -1) {
                this.client.settings.messengerSettings.availableMessengers.splice(this.client.settings.messengerSettings.availableMessengers.indexOf(messenger), 1);
            } else {
                this.client.settings.messengerSettings.availableMessengers.push(messenger);
            }
        },
        deleteProvider(index) {
            this.client.settings.messengerSettings.providers.splice(index, 1);
        },
        addProvider()
        {
            this.client.settings.messengerSettings.providers.push({type: '', provider: ''})
        }
    }
};
</script>

<style scoped>
.switch-item {
    margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/messengers.vue